// import debug from "debug";
// const log = debug('site-nav-narrow');

export default class SiteNavNarrow {
	constructor(element, options) {
		this.element = element;
		this.options = options;

		// get references to required elements
		this.openButton = this.options.openButton;
		this.closeButton = this.options.closeButton;
		this.overlay = this.options.overlay;
		this.openClass = this.options.openClass;
		this.siteHeader = this.options.siteHeader;
		this.siteHeaderNarrow = this.options.siteHeaderNarrow;
		this.siteSearch = this.options.siteSearch;

		this.boundOnFocus = this.onFocus.bind(this);
		this.boundDismissalListener = this.dismissalListener.bind(this);

		// If you are changing this breakpoint:
		// Be sure to change the SASS setting $settings__wide_header_breakpoint to match
		// client\src\site__def\sass-settings\breakpoints.scss
		this.mediaQuery = window.matchMedia("(min-width: 68.75em)");

		this.init();
		this.watch();
	}

	init() {
		// initial state is hidden
		this.makeNavigationUnreachable();
	}

	watch() {
		this.openButton.addEventListener(
			"click",
			this.openSiteNavigation.bind(this)
		);
		this.closeButton.addEventListener(
			"click",
			this.closeSiteNavigation.bind(this)
		);
		this.overlay.addEventListener(
			"click",
			this.closeSiteNavigation.bind(this)
		);
		this.element.addEventListener(
			"click",
			this.dismissalListener.bind(this)
		);

		this.mediaQuery.addListener(this.onMediaQueryChange.bind(this));
	}

	openSiteNavigation() {
		// close the site search (method defined in site-search.js)
		if (this.siteSearch && this.siteSearch.instance) {
			this.siteSearch.instance.closeSiteSearch();
		}

		// Remove interaction blocking from nav
		this.makeNavigationReachable();

		// Slides the menu open
		this.element.classList.add(this.openClass);

		// Shows the overlay
		this.overlay.removeAttribute("hidden");

		// Focus the close button
		this.closeButton.focus();

		// Adds interaction blocking to rest of page
		this.makePageContentUnreachable();

		// Adds focus restriction for nav
		this.restrictFocus();

		// Adds dismissal listener
		this.addDismissalListener();
	}

	closeSiteNavigation() {
		// Removes interaction blocking from rest of page
		this.makePageContentReachable();

		// Removes focus restriction for nav
		this.removeFocusRestriction();

		// Slides the menu closed
		this.element.classList.remove(this.openClass);

		// Hides the overlay
		this.overlay.setAttribute("hidden", "");

		// Focus the open button
		this.openButton.focus();

		// Adds interaction blocking to nav
		this.makeNavigationUnreachable();

		// Removes the dismissal listener
		this.removeDismissalListener();
	}

	makeNavigationUnreachable() {
		// block screen reader access
		this.element.setAttribute("aria-hidden", true);

		// block keyboard access
		var interactiveElements = this.element.querySelectorAll("a,button");
		for (var i = 0; i < interactiveElements.length; i++) {
			var element = interactiveElements[i];
			element.setAttribute("tabindex", -1);
		}
	}

	makeNavigationReachable() {
		// reinstates screen reader access
		this.element.removeAttribute("aria-hidden");

		// reinstates keyboard access
		var interactiveElements = this.element.querySelectorAll("a,button");
		for (var i = 0; i < interactiveElements.length; i++) {
			var element = interactiveElements[i];
			element.removeAttribute("tabindex");
		}
	}

	makePageContentUnreachable() {
		const pageElements = document.querySelectorAll("body > *");
		const pageElementsArray = Array.prototype.slice.call(pageElements);
		const siteHeader = this.siteHeader;

		pageElementsArray.forEach(function (element) {
			const isSiteHeader = element == siteHeader;
			if (!isSiteHeader) {
				element.setAttribute("aria-hidden", true);
			}
		});

		this.siteHeaderNarrow.setAttribute("aria-hidden", true);
	}

	makePageContentReachable() {
		const pageElements = document.querySelectorAll("body > *");
		const pageElementsArray = Array.prototype.slice.call(pageElements);
		const siteHeader = this.siteHeader;

		pageElementsArray.forEach(function (element) {
			const isSiteHeader = element == siteHeader;
			if (!isSiteHeader) {
				element.removeAttribute("aria-hidden");
			}
		});

		this.siteHeaderNarrow.removeAttribute("aria-hidden");
	}

	restrictFocus() {
		document.addEventListener("focus", this.boundOnFocus, true);
	}

	removeFocusRestriction() {
		document.removeEventListener("focus", this.boundOnFocus, true);
	}

	// Bound to this in the constructor as this.boundOnFocus
	onFocus(event) {
		if (!this.element.contains(event.target)) {
			event.stopPropagation();
			this.focusNav();
		}
	}

	focusNav() {
		var focusableElement = this.element.querySelector(
			"input,select,button,a[href]"
		);
		if (focusableElement) {
			focusableElement.focus();
		} else {
			this.closeButton.focus();
		}
	}

	addDismissalListener() {
		document.addEventListener("keydown", this.boundDismissalListener);
	}

	removeDismissalListener() {
		document.removeEventListener("keydown", this.boundDismissalListener);
	}

	// Bound to this in the constructor as this.boundDismissalListener
	dismissalListener(event) {
		var isTargetInModal = this.element.contains(event.target);
		var wasEscapePressed = event.keyCode === 27;
		var hasKeyCode = event.keyCode ? true : false;
		if (wasEscapePressed || (!hasKeyCode && !isTargetInModal)) {
			this.closeSiteNavigation();
		}
	}

	onMediaQueryChange(event) {
		if (event.matches) {
			this.transitionToWide();
		} else {
			this.transitionToNarrow();
		}
	}

	transitionToWide() {
		// when transitioning to wide, close the navigation
		this.closeSiteNavigation();
	}

	transitionToNarrow() {
		// when transitioning to narrow, reset focus to open button (if focus is in header)
		if (this.siteHeader.contains(document.activeElement)) {
			this.openButton.focus();
		}
	}
}



// WEBPACK FOOTER //
// ./project/client/src/core/components/site-nav-narrow/site-nav-narrow.js